



























































import {Vue, Component, Watch} from "vue-property-decorator";
import {LoginState} from "@/store/modules/user";
import Login from "@/script/login";

@Component({
    components: {},
})
export default class Leave extends Vue {
    reason: string = "";
    check1: boolean = false;
    check2: boolean = false;

    async mounted() {
        const loginState = await this.$store.dispatch("loginState");
        switch (loginState) {
            case LoginState.login:
                return;
        }
    }

    async leave(state: boolean) {
        if (state) {
            const result = await this.$api.leave(this.reason);
            if (!result || result.error) {
                result && result.error && alert(result.error.message);
                console.error((result && result.error) || "error");
            }
            else {
                await Login.logout();
                await this.$router.replace("/");
            }
            console.log(result);
        }
    }

    openModal() {
        if (!this.check1) {
            alert(this.$t('leave.account.agreement.required'))
        }
        else {
            this.$modal.show('deleteAccount')
        }
    }
}
